// AUTO-GENERATED at install/build time. DO NOT EDIT BY HAND.
// Regenerated by scripts/generate-version.js (postinstall, prestart, prebuild).
// Gitignored. If missing, run `node scripts/generate-version.js`.

export const APP_VERSION = '2.14.10';
export const APP_BRANCH = 'alexandru-dev';
export const APP_COMMIT = 'f8eab372';
export const APP_BUILT_AT = '2026-07-27T08:47:23.038Z';
